"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../constants/themeContants");

var _theming = require("../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Anchor = function Anchor(_ref) {
  var children = _ref.children,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["children", "className"]);

  return _react["default"].createElement(AComponent, _extends({
    className: className
  }, restProps), children);
};

Anchor.themeProps = {
  anchor: {
    name: "Anchor",
    description: "HTML anchor link",
    type: _themeContants.themePropTypes.style
  }
};

var AComponent = _styledComponents["default"].a.withConfig({
  displayName: "Anchor__AComponent",
  componentId: "sc-1uqce3w-0"
})(["text-decoration:none;color:currentColor;&:hover,&:active,&:focus{text-decoration:none;color:currentColor;outline:none;}", ";"], (0, _theming.applyVariants)(Anchor.themeProps.anchor));

exports.AComponent = AComponent;
Anchor.defaultProps = {
  className: ""
};
Anchor.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string
};
var _default = Anchor;
exports["default"] = _default;